import { Navigate, useLocation } from 'react-router-dom';
import { authManager } from '../services/authManager';

/**
 * Componente para proteger rutas que requieren autenticación
 * 
 * Si el usuario está autenticado, renderiza el children
 * Si no está autenticado, redirige a /login
 */
export default function ProtectedRoute({ children }) {
  const location = useLocation();
  const isAuthenticated = authManager.isAuthenticated();

  if (!isAuthenticated) {
    // Guardar la ruta a la que intentaba acceder
    const currentPath = window.location.pathname;
    sessionStorage.setItem('redirectAfterLogin', currentPath);
    
    // Redirigir a login
    return <Navigate to="/login" replace />;
  }

  if (authManager.getCurrentUser()?.mustChangePassword && location.pathname !== '/trial/start') {
    return <Navigate to="/trial/start" replace />;
  }

  return children;
}

